let registrationBaseUrl = "/api/";

if (process.env.NODE_ENV === "development") {
  registrationBaseUrl = "/api" + registrationBaseUrl;
}
registrationBaseUrl =
  process.env.REACT_APP_REGISTRATION_API_URL || registrationBaseUrl;

let validateEmail = params => ({
  url:
    registrationBaseUrl +
    `validate/email/${params.email}?domain=${params.domain}`,
  method: "GET"
});

let validateToken = token => ({
  url: registrationBaseUrl + `validate/token/${token}`,
  method: "GET"
});

let invValidation = params => ({
  url:
    registrationBaseUrl +
    `validate/invoice?` +
    `cmf=${params.cmf}&` +
    `invoiceNumber=${params.lastInvoiceNumber}&` +
    `invoiceAmount=${params.lastInvoiceAmount}`,
  method: "GET"
});

let registerUser = data => ({
  url: registrationBaseUrl + "register/user",
  method: "PUT",
  data: data
});

module.exports = {
  validateEmail: validateEmail,
  validateToken: validateToken,
  invValidation: invValidation,
  registerUser: registerUser
};
